/* VB · banner de cookies propio (snippets/vb-cookies.liquid).
   Usa la API de privacidad de Shopify: solo se abre si customerPrivacy.shouldShowBanner() y guarda la respuesta con
   setTrackingConsent (la leen píxeles, canales y apps). Si la API no carga, no se abre y queda el banner nativo.
   Mientras está abierto: scroll bloqueado (html.vb-cc-lock) y foco atrapado en el panel. */
(() => {
  if (window.__vbCookies) return;
  window.__vbCookies = true;
  const root = document.querySelector('[data-vb-cc]');
  if (!root || (window.Shopify && Shopify.designMode)) return;
  const html = document.documentElement;
  const card = root.querySelector('.vb-cc__card');
  const prefs = root.querySelector('[data-vb-cc-prefs]');

  // El logo del panel se parte en letras para la entrada (misma familia que el logo del pie)
  let n = 0;
  root.querySelectorAll('.vb-cc__logo-light, .vb-cc__logo-bold').forEach((part) => {
    const txt = part.textContent;
    part.textContent = '';
    [...txt].forEach((ch) => {
      const s = document.createElement('span');
      s.className = 'vb-cc__lt';
      s.style.setProperty('--i', n++);
      s.textContent = ch;
      part.appendChild(s);
    });
  });

  const withPrivacy = (cb) => {
    if (window.Shopify && Shopify.customerPrivacy) return cb(Shopify.customerPrivacy);
    if (!(window.Shopify && Shopify.loadFeatures)) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
      if (err || !Shopify.customerPrivacy) return;
      cb(Shopify.customerPrivacy);
    });
  };

  let lastFocus = null;
  const open = () => {
    lastFocus = document.activeElement;
    html.classList.add('vb-cc-on'); // oculta el banner nativo solo cuando el propio funciona
    root.hidden = false;
    if (root.dataset.lock === 'true') html.classList.add('vb-cc-lock');
    void root.offsetWidth; // reflow: la transición arranca desde el estado cerrado (rAF se congela en pestañas ocultas)
    root.classList.add('is-open');
    setTimeout(() => card.focus({ preventScroll: true }), 60);
  };
  const close = () => {
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    html.classList.remove('vb-cc-lock');
    setTimeout(() => { root.hidden = true; root.classList.remove('is-closing'); }, document.hidden ? 0 : 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  const save = (consent) => {
    withPrivacy((cp) => {
      cp.setTrackingConsent({ ...consent, sale_of_data: consent.marketing }, () => {
        document.dispatchEvent(new CustomEvent('vb:consent', { detail: consent }));
      });
    });
    close();
  };

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-cc-accept]')) return save({ analytics: true, marketing: true, preferences: true });
    if (e.target.closest('[data-cc-reject]')) return save({ analytics: false, marketing: false, preferences: false });
    if (e.target.closest('[data-cc-settings]')) {
      prefs.hidden = false;
      root.classList.add('is-prefs');
      root.querySelector('[data-cc-settings]').hidden = true;
      root.querySelector('[data-cc-accept]').hidden = true;
      root.querySelector('[data-cc-save]').hidden = false;
      prefs.querySelector('input:not([disabled])')?.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('[data-cc-save]')) {
      const v = (k) => !!prefs.querySelector(`[data-cc="${k}"]`)?.checked;
      return save({ analytics: v('analytics'), marketing: v('marketing'), preferences: v('preferences') });
    }
  });

  // Foco atrapado dentro del panel mientras está abierto (sin cierre con Esc: hay que elegir)
  document.addEventListener('keydown', (e) => {
    if (root.hidden || e.key !== 'Tab') return;
    const f = [...card.querySelectorAll('a[href], button:not([hidden]), input:not([disabled])')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Reabrir desde cualquier enlace con [data-vb-cc-open] (p. ej. «Configurar cookies» del pie)
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-vb-cc-open]');
    if (!o) return;
    e.preventDefault();
    withPrivacy(() => open());
  });

  withPrivacy((cp) => {
    // shouldShowBanner() solo dice si la región exige banner (sigue en true tras responder): abrir solo si aún no hay
    // respuesta guardada («yes»/«no») en currentVisitorConsent()
    try {
      if (!(cp.shouldShowBanner && cp.shouldShowBanner())) return;
      const c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      const answered = ['analytics', 'marketing', 'preferences'].some((k) => c && (c[k] === 'yes' || c[k] === 'no'));
      if (!answered) open();
    } catch (err) { /* API distinta: queda el nativo */ }
  });
})();
